module.exports = __webpack_public_path__ + "static/media/details-12-image-2.405e7d62.jpg";